var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 163,
    viewBox: "0 0 141 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_50067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.5 0V163H0.5L140.5 0Z",
    fill: "url(#paint0_linear_1524_50067)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1524_50067",
    x1: 0.5,
    y1: 81.5,
    x2: 140.5,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49517D",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49517D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_50067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 163,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleOverlay);
export default __webpack_public_path__ + "static/media/triangle_overlay.962790e701cb35f818bb0719b5476cfd.svg";
export { ForwardRef as ReactComponent };